// extracted by mini-css-extract-plugin
export default {"section":"gkCjjq0qlpsLl9Kppwe_","header":"a6SbUG8eld07jxZgeYrz","cards":"STAyBo7grrba1PkTHEKz","titleBreak":"XlgOLzFOxkYLr282HusI"};